export function statYearSelect() {
    
  const year_filter = document.querySelector("[name=filter_year]");
  const region_filter = document.querySelector("[name=filter_region]");
  const tilesBlock = document.querySelectorAll(".stat_tiles");

     
    if(year_filter) {
          year_filter.addEventListener("change", function (e) {
            let select = e.target;
            let year = select.options[select.selectedIndex].value;
            // tilesBlock exist
            tilesBlock.forEach((block) => {
              let links = block.querySelectorAll(".stat-tile-link");

              links.forEach((link) => {
                link.href = link.href.replace(/(year=)[^\&]+/, "$1" + year);
              });
            });
          });
          
        region_filter.addEventListener("change", function (e) {
          let select = e.target;
          var region = select.options[select.selectedIndex].value;
          // tilesBlock exist
          tilesBlock.forEach((block) => {
            let links = block.querySelectorAll(".stat-tile-link");

            links.forEach((link) => {
              link.href = link.href.replace(/(RegionId=)[^\&]+/, "$1" + region);
            });
          });
        });
    }
  };



// function CHANGEME(replaceString) {

//     const tilesBlock = document.querySelectorAll(".stat_tiles");

//     if (tilesBlock) {
//         // tilesBlock exist
//         tilesBlock.forEach((block) => {
//           let links = block.querySelectorAll(".stat-tile-link");

//           links.forEach((link) => {
//             link.href = link.href.replace(replaceString);
//           });
//         });
//       }
// }

